<div class="lichsu-chuyenlop-container">
  <!-- Data Table Section -->
  <div class="card data-card">
    <div class="card-header bg-gradient-danger text-white">
      <div class="d-flex align-items-center justify-content-between">
        <div>
          <i class="fas fa-history mr-2"></i>
          <strong>Lịch sử chuyển lớp</strong>
        </div>
        <span class="badge badge-light">{{totalItems || 0}} bản ghi</span>
      </div>
    </div>
    <div class="card-body p-0">
      <div class="table-wrapper">
        <table class="table table-hover table-sm mb-0">
          <thead class="thead-light">
            <tr>
              <th style="width:60px;text-align:center">
                <i class="fas fa-hashtag"></i> STT
              </th>
              <th style="min-width:160px">
                <i class="fas fa-calendar-alt mr-1"></i>Ngày chuyển
              </th>
              <th style="min-width:130px">
                <i class="fas fa-user-tie mr-1"></i>Người chuyển
              </th>
              <th style="min-width:150px">
                <i class="fas fa-arrow-right mr-1 text-danger"></i>Lớp cũ
              </th>
              <th style="min-width:150px">
                <i class="fas fa-arrow-right mr-1 text-success"></i>Lớp mới
              </th>
              <th style="min-width:200px">
                <i class="fas fa-comment-dots mr-1"></i>Lý do
              </th>
              <th style="min-width:200px">
                <i class="fas fa-sticky-note mr-1"></i>Ghi chú
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let u of datas" class="data-row">
              <td style="text-align:center">
                <span class="badge badge-secondary">{{u.STT}}</span>
              </td>
              <td>
                <div class="datetime-info">
                  <i class="far fa-calendar mr-1 text-primary"></i>
                  <span>{{u.Ngay | date: 'dd/MM/yyyy'}}</span>
                </div>
                <div class="datetime-info">
                  <i class="far fa-clock mr-1 text-muted"></i>
                  <small class="text-muted">{{u.Ngay | date: 'HH:mm'}}</small>
                </div>
              </td>
              <td>
                <div class="user-info">
                  <i class="fas fa-user-circle mr-1 text-info"></i>
                  <span>{{u.CreatedBy}}</span>
                </div>
              </td>
              <td>
                <div class="class-badge old-class">
                  <i class="fas fa-chalkboard-teacher mr-1"></i>
                  <strong>{{u.LopCu}}</strong>
                </div>
              </td>
              <td>
                <div class="class-badge new-class">
                  <i class="fas fa-chalkboard-teacher mr-1"></i>
                  <strong>{{u.Lop}}</strong>
                </div>
              </td>
              <td>
                <div class="reason-text">
                  <i class="fas fa-info-circle mr-1 text-warning"></i>
                  <span>{{u.LyDo}}</span>
                </div>
              </td>
              <td>
                <span class="text-muted">{{u.GhiChu}}</span>
              </td>
            </tr>
            <tr *ngIf="!datas || datas.length === 0">
              <td colspan="7" class="text-center text-muted py-4">
                <i class="fas fa-inbox fa-2x mb-2 d-block"></i>
                Chưa có lịch sử chuyển lớp
              </td>
            </tr>
          </tbody>
          <!-- Summary Footer -->
          <tfoot *ngIf="datas && datas.length > 0" class="summary-footer">
            <tr>
              <td colspan="7" class="summary-row">
                <div class="summary-content">
                  <i class="fas fa-chart-line mr-2"></i>
                  <strong>TỔNG SỐ LẦN CHUYỂN LỚP:</strong>
                  <span class="total-count">{{datas.length}}</span>
                  <span class="summary-label">lần</span>
                </div>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>

    <!-- Transfer Flow Indicator -->
    <div class="transfer-flow" *ngIf="datas && datas.length > 0">
      <div class="flow-content">
        <span class="flow-badge old">
          <i class="fas fa-graduation-cap mr-1"></i>
          Lớp cũ
        </span>
        <i class="fas fa-arrow-right fa-2x flow-arrow"></i>
        <span class="flow-badge new">
          <i class="fas fa-graduation-cap mr-1"></i>
          Lớp mới
        </span>
      </div>
    </div>
  </div>
</div>

<!-- Footer -->
<div class="modal-footer border-top bg-light">
  <div class="d-flex justify-content-between align-items-center w-100">
    <!-- Pagination -->
    <div class="pagination-wrapper" *ngIf="totalItems >= 10">
      <ul class="pagination mb-0">
        <li class="page-item" [ngClass]="{disabled: currentPage === 1}">
          <a class="page-link" (click)="setPage(1)"><<</a>
        </li>
        <li class="page-item" [ngClass]="{disabled: currentPage === 1}">
          <a class="page-link" (click)="setPage(currentPage - 1)"><</a>
        </li>
        <li class="page-item" *ngFor="let page of pages" [ngClass]="{active: currentPage === page.Id}">
          <a class="page-link" (click)="setPage(page.Id)">{{page.Id}}</a>
        </li>
        <li class="page-item" [ngClass]="{disabled: currentPage === totalPages}">
          <a class="page-link" (click)="setPage(currentPage + 1)">></a>
        </li>
        <li class="page-item" [ngClass]="{disabled: currentPage === totalPages}">
          <a class="page-link" (click)="setPage(totalPages)">>></a>
        </li>
        <li class="page-item">
          <input 
            type="number" 
            class="form-control form-control-sm page-size-input" 
            [(ngModel)]="pageSize" 
            (blur)="search1()" />
        </li>
        <li class="page-item">
          <span class="page-link total-info">
            <strong>Tổng: {{totalItems | number}}</strong>
          </span>
        </li>
      </ul>
    </div>

    <!-- Close Button -->
    <div>
      <button class="btn btn-secondary btn-close" (click)="save_chondoituong()" title="Ấn ESC để thoát">
        <i class="fas fa-times mr-1"></i>
        Đóng lại
      </button>
    </div>
  </div>
</div>
